export default __webpack_public_path__ + "locales/tr/Errors.json?hash=03c7ca2929e04e7b64bc2caa5cfd8017";